<tg-row>
    <tg-col md="9" sm="12">
        <tg-row>
            <tg-col md="6" sm="12" *ngIf="!isSummaryStep">
                <button tgButton2 tgStyle="primary" class="property-page-footer__margin-right"
                    (click)="onContinueTo()">
                    Continue to {{ continueToTitle$ | async }}
                </button>

                <tm-start-over-button *ngIf="!isEditOrRelistPage" [disabled]="
                        (isLoadingEmitter$ | async) ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success">
                </tm-start-over-button>
            </tg-col>

            <tg-col md="6" sm="12" *ngIf="isSummaryStep && isEditOrRelistPage"
                class="property-page-footer__summary-save-change">
                <button tgButton2 [tgStyle]="isEnoughBalance ? 'secondary' : 'primary'" (click)="onShowTopUpModal(true)"
                    class="property-page-footer__summary-save-change--button" [disabled]="
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success
                    " *ngIf="isUpgradePackage || isIncreasePricingTier">
                    Top up my account
                </button>

                <button *ngIf="isRelistPage" (click)="onEditOrRelistListing()" tgButton2 tgStyle="primary"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success ||
                        (!isAgent && !isEnoughBalance)
                    " [tgLoading]="listingActionLoading$ | async">
                    Start my listing
                </button>

                <button *ngIf="isEditPage" (click)="onEditOrRelistListing()" tgButton2 tgStyle="primary"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success ||
                        (!isAgent && !isEnoughBalance)
                    " [tgLoading]="(listingActionLoading$ | async) === true">
                    Update my listing
                </button>
            </tg-col>

            <tg-col md="6" sm="12" *ngIf="isSummaryStep && !isEditOrRelistPage"
                class="property-page-footer__summary-topup">
                <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success
                    " *ngIf="!isAgent">
                    Top up my account
                </button>

                <button tgButton2 tgStyle="primary" class="property-page-footer__summary-create-listing--button"
                    (click)="onCreateListing()" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionResponse$ | async)?.success
                    " [tgLoading]="listingActionLoading$ | async">
                    Start my listing
                </button>
            </tg-col>

            <tg-col *ngIf="!isEditOrRelistPage" md="4" sm="12" [ngClass]="{
                    'property-page-footer__save-and-complete-later--centre':
                        isCompact
                }">
                <button tgButton2 linkStyle class="property-page-footer__save-and-complete-later"
                    (click)="onSaveAndCompleteLater()" [disabled]="
                        (isLoadingEmitter$ | async) ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success">
                    Save and exit
                </button>
            </tg-col>
        </tg-row>
    </tg-col>
</tg-row>

<tg-modal *ngIf="isCreditAccountModalVisible" (close)="onShowTopUpModal(false)"
    class="property-page-footer__credit-account-modal" fullscreen>
    <tmp-credit-account (cancelled)="onShowTopUpModal(false)" (creditAdded)="onCreditAdded()"
        (topupFailed)="onCreditFailure()">
    </tmp-credit-account>
</tg-modal>